import { useEffect, useRef } from "react";
import { Layout } from "@/components/layout/Layout";
import { useSeoMeta } from "@/hooks/useSeoMeta";
import { GlobalSchema } from "@/components/seo/GlobalSchema";
import { JsonLd } from "@/components/seo/JsonLd";
import { breadcrumbSchema } from "@/components/seo/schemas";
import { useSchemaIndexable } from "@/components/seo/useSchemaIndexable";

export default function Contact() {
  const containerRef = useRef<HTMLDivElement>(null);

  useSeoMeta({
    pageType: "static_page",
    entityId: "contacto",
    variables: { titulo_pagina: "Contacto" },
    canonicalPath: "/contacto/",
  });

  const isIndexable = useSchemaIndexable("static_page", "contacto");

  // Load Tally embed script once
  useEffect(() => {
    const TALLY_SCRIPT_URL = "https://tally.so/widgets/embed.js";

    const loadEmbeds = () => {
      if (typeof (window as any).Tally !== "undefined") {
        (window as any).Tally.loadEmbeds();
      } else {
        document
          .querySelectorAll("iframe[data-tally-src]:not([src])")
          .forEach((el) => {
            (el as HTMLIFrameElement).src = (el as HTMLIFrameElement).dataset.tallySrc!;
          });
      }
    };

    if (typeof (window as any).Tally !== "undefined") {
      loadEmbeds();
      return;
    }

    // Don't add script twice
    if (document.querySelector(`script[src="${TALLY_SCRIPT_URL}"]`)) {
      loadEmbeds();
      return;
    }

    const script = document.createElement("script");
    script.src = TALLY_SCRIPT_URL;
    script.onload = loadEmbeds;
    script.onerror = loadEmbeds;
    document.body.appendChild(script);

    return () => {
      // Don't remove script on unmount — Tally reuses it
    };
  }, []);

  const breadcrumbs = breadcrumbSchema([
    { name: "Inicio", path: "/" },
    { name: "Contacto", path: "/contacto/" },
  ]);

  const contactPageSchema = {
    "@type": "ContactPage",
    name: "Contacto",
    url: "https://bandflow.es/contacto/",
    description:
      "Contacta con Bandflow para sugerencias, soporte o colaboraciones. Te respondemos lo antes posible.",
  };

  return (
    <Layout>
      <GlobalSchema pageType="static_page" entityId="contacto" />
      {isIndexable && <JsonLd data={[breadcrumbs, contactPageSchema]} />}

      <div className="container py-10 md:py-14">
        <div className="mx-auto max-w-2xl">
          <h1 className="font-display text-3xl font-bold tracking-tight md:text-4xl">
            Contacto
          </h1>
          <p className="mt-2 text-muted-foreground">
            ¿Tienes alguna duda, sugerencia o propuesta? Escríbenos y te respondemos lo antes posible.
          </p>

          <div className="mt-8" ref={containerRef}>
            <iframe
              data-tally-src="https://tally.so/embed/ODPleM?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
              loading="lazy"
              width="100%"
              height={717}
              frameBorder={0}
              marginHeight={0}
              marginWidth={0}
              title="Formulario de contacto"
              style={{ border: "none" }}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
